<div
  class="default-overlay !content-start pt-[5rem]"
  appAlert
  [show]="show"
  (showChange)="showChange($event)"
>
  <div class="description">
    Buy in a seat for
    <div class="coins">{{ amount }} Coins</div>
  </div>
</div>
